const LOCALES = {
  ENGLISH: 'en-US',
  RUSSIAN: 'ru-RU'
};

export default LOCALES;
